// extracted by mini-css-extract-plugin
export default {"container":"tag_container__YNxI-","first":"tag_first__vxfOG","btn":"tag_btn__t1DAh","all":"tag_all__P0UEZ","client":"tag_client__3uPvz"};